var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ShortCut'),_vm._v(" "),_c('LogoHome'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('el-carousel',{attrs:{"indicator-position":"outside","height":_vm.bannerHeight + 'px'}},_vm._l((_vm.imgList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item}})])}),1),_vm._v(" "),_c('Notice')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0c66d94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = null
// module chunks = 